<template>
  <el-dialog :title="setTitle" :visible="show" width="70%" @close="closeWindow" class="dialog_container">
    <div class="add-title">
      <div>
        <div v-for="(item, index) in showList" :key="index" class="list-1" :class="{ change: tapId == item.id }"
          @click="chioceId(item.id)">
          <div>{{ item.name }}</div>
        </div>
      </div>
      <div>
        <div v-show="tapId == 1">
          <CustomerInfo @customerData="customerData" :formData="formData" @oldData="oldData" :setTitle="setTitle">
          </CustomerInfo>
        </div>
        <div v-show="tapId == 2">
          <InfoServices :formData="formData" :customerId="formData.id" :setTitle="setTitle"></InfoServices>
        </div>
        <div v-if="tapId == 3">
          <deviceBuild :customerId="formData.id" ref="build" :key="deviceBuildKey" :tapId="tapId"></deviceBuild>
        </div>
      </div>
    </div>
    <div class="btn">
      <div>
        <el-button :disabled="setTitle == '查看'" type="primary" @click="send" v-if="tapId == 1">保存</el-button>
        <el-button @click="closeWindow">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import CustomerInfo from "./customerInfo.vue"
import InfoServices from "./infoServices.vue"
import deviceBuild from "./deviceBuild.vue";
import exportVue from "@/utils/exportVue"
export default {
  components: {
    CustomerInfo,
    InfoServices,
    deviceBuild
  },
  name: "AddInfo",
  props: {
    showStatus: {
      type: Boolean,
      default: false,
    },
    setTitle: {
      type: String,
      default: "",
    },
    formData: {},
  },
  data() {
    return {
      tapId: "2",
      showList: [
        {
          id: "1",
          name: "客户资料",
        },
        {
          id: "2",
          name: "设备绑定",
        },
        {
          id: "3",
          name: "设备安装",
        },
      ],
      wcustomerData: {},
      wGovernmentAssistance: {},
      oldData: {},
      deviceBuildKey: 0
    }
  },
  computed: {
    show() {
      return this.showStatus
    },
  },
  created() {
    this.$emit("oldData", this.oldData)
  },
  watch: {
    showStatus(newVal) {
       if(newVal){
         this.deviceBuildKey = Date.now();
       }
    },
    formData: {
      handler(val) {
        // this.formData =val
        this.tapId=2
      },
      deep: true,
      immediate: true,
    },
    setTitle(val) {
      if (val == '查看') {
        this.tapId = '1'
      } else {
        this.tapId = '2'
      }
    },
     tapId(newVal, oldVal) {
        if(newVal==2){
          //  exportVue.$emit("getClick",this.formData.id)
        }
     }
  },
  methods: {
    chioceId(id) {
      this.tapId = id
    },
    send() {
      let url = ""
      url = "/ypt/admin/all/customer/info/update"
      let parmar = this.wcustomerData
      this.$http
        .request({
          url: url,
          method: "POST",
          data: this.wcustomerData,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(`操作成功`)
            this.wcustomerData = {}
            this.$emit("updateShowStatus", true)
          }
        })
    },

    closeWindow() {
      this.$emit("updateShowStatus", false)
      this.tapId = 3
      exportVue.$emit("closeW", true)
    },
    customerData(data) {
      this.wcustomerData = data
    },
  },
}
</script>
<style lang="less" scoped>
.dialog_container {
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e5e5e5;
  }
}

.btn {
  width: 100%;
  display: flex;
  margin-top: 30px;
  justify-content: center;
}

.add-title {
  width: 100%;
  display: flex;
}

.add-title>div:first-child {
  width: 120px;
  background-color: #a2aaaa;
}

.add-title>div:nth-child(2) {
  flex: 1;
}

.list-1 {
  width: 100%;
  margin: 0 auto;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-bottom: 20px;
  cursor: pointer;
}

.change {
  width: calc(100% - 2px);
  color: #0000ff;
  background-color: #e0f0fa;
  border-left: 2px solid #0000ff;
}
</style>
